(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Note: the hero (.cn-hero__content children) animates via pure CSS
  // (@keyframes cn-hero-in), independent of this script, so above-the-fold
  // content is never gated on JS/GSAP loading successfully.

  // Collection description: clamp long copy on load, toggle with "Read more".
  function initCollectionDesc() {
    var wrap = document.querySelector('[data-cn-desc]');
    if (!wrap) return;
    var body = wrap.querySelector('.cn-colhead__desc-body');
    var btn = wrap.querySelector('[data-cn-more]');
    if (!body || !btn) return;
    wrap.setAttribute('data-clamped', '');
    if (body.scrollHeight <= body.clientHeight + 4) { wrap.removeAttribute('data-clamped'); return; }
    btn.addEventListener('click', function () {
      var open = wrap.hasAttribute('data-expanded');
      if (open) { wrap.removeAttribute('data-expanded'); wrap.setAttribute('data-clamped', ''); }
      else { wrap.removeAttribute('data-clamped'); wrap.setAttribute('data-expanded', ''); }
      btn.textContent = open ? 'Read more' : 'Read less';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionDesc);
  } else {
    initCollectionDesc();
  }

  // Product cards are animated by the theme's own fade-up (banner_animation), so they are not listed here.
  function tagRevealTargets() {
    var selectors = [
      '.cn-trust-item',
      '.cn-feature',
      '.shopify-section .image-banner__content',
      '.shopify-section .spotlight-block__content',
      '.shopify-section .customer-testimonial'
    ];
    var nodes = document.querySelectorAll(selectors.join(','));
    nodes.forEach(function (el) {
      if (!el.classList.contains('cn-reveal')) el.classList.add('cn-reveal');
    });
    return nodes;
  }

  function revealAllImmediately(nodes) {
    nodes.forEach(function (el) { el.classList.add('is-visible'); });
  }

  function init() {
    if (reduceMotion || typeof gsap === 'undefined') {
      return; // content stays visible via default CSS; no reduced-motion penalty
    }

    document.documentElement.classList.add('js-cn-motion');
    var targets = tagRevealTargets();

    try {
      if (typeof ScrollTrigger === 'undefined') {
        revealAllImmediately(targets);
        return;
      }

      gsap.registerPlugin(ScrollTrigger);

      // Batch product grids for a natural wave stagger
      ScrollTrigger.batch('.product-item.cn-reveal', {
        start: 'top 92%',
        onEnter: function (batch) {
          gsap.to(batch, {
            opacity: 1, y: 0, duration: 0.5, stagger: 0.06, ease: 'power2.out',
            onStart: function () { batch.forEach(function (el) { el.classList.add('is-visible'); }); }
          });
        },
        once: true
      });

      // Feature cards + generic content blocks: single fade/rise reveal
      document.querySelectorAll('.cn-reveal:not(.product-item):not(.cn-trust-item)').forEach(function (el) {
        ScrollTrigger.create({
          trigger: el,
          start: 'top 90%',
          once: true,
          onEnter: function () { el.classList.add('is-visible'); }
        });
      });

      // Trust bar: small stagger
      var trustItems = document.querySelectorAll('.cn-trust-item.cn-reveal');
      if (trustItems.length) {
        ScrollTrigger.create({
          trigger: trustItems[0].closest('.cn-trust-bar') || trustItems[0],
          start: 'top 90%',
          once: true,
          onEnter: function () {
            trustItems.forEach(function (el, i) {
              setTimeout(function () { el.classList.add('is-visible'); }, i * 80);
            });
          }
        });
      }
    } catch (err) {
      // Any GSAP/ScrollTrigger failure must never leave content permanently hidden.
      revealAllImmediately(targets);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
